/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_ClarityInputs */

const en_score_clarity = /** @type {(inputs: Score_ClarityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language & Grammar`)
};

const de_score_clarity = /** @type {(inputs: Score_ClarityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache & Grammatik`)
};

/**
* | output |
* | --- |
* | "Language & Grammar" |
*
* @param {Score_ClarityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_clarity = /** @type {((inputs?: Score_ClarityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_ClarityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_clarity(inputs)
	return en_score_clarity(inputs)
});